import { Dispatch, SetStateAction } from "react";
import { TMember } from "types/auth/authTypes";
import { TVerificationSseRes } from "types/signup/signUpTypes";

type TFetchSseProps = {
  phoneNumber?: string;
  email?: string;
  to: "sms" | "email";
  setResult: Dispatch<SetStateAction<TVerificationSseRes>>;
  memberType: TMember;
  verificationId: string;
};

export const useFetchSSE = () => {
  let eventSource: EventSource;

  const fetchSse = async ({ to, setResult, verificationId }: TFetchSseProps) => {
    try {
      console.log(verificationId);
      eventSource = new EventSource(
        `${process.env.API_URL}/verification/${
          to === "sms" ? "sms" : "email"
        }/?verificationId=${verificationId}`,
        {
          withCredentials: true,
        }
      );
      eventSource.onmessage = async (event) => {
        const { data: returnValue } = await event;
        const newData = JSON.parse(returnValue);

        if (newData.code) {
          setResult(newData);
          eventSource.close();
        }
      };
      eventSource.onerror = () => {
        eventSource.close();
      };
    } catch (error) {
      throw new Error(error as any);
    }
  };

  return { fetchSse };
};
